import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { ResponseError } from 'lib/apis/core';
import { NextCustomPageProps } from 'types/extendedNextTypes';
import { withGetLayout } from 'lib/utils/helpers/withGetLayout';

export const pageResolver = <T = {}> (
  pageModule: NextCustomPageProps<T>,
  ssrFn: GetServerSideProps,
  pageType: 'regular' | 'plp' | 'agency' | 'empty' | 'profile' = 'regular'
) => {
  const getServerSideProps: GetServerSideProps = async (context) => {
    const { res, locale } = context;
    console.log('IM here');
    const localeProps = await serverSideTranslations(locale || 'fa', [
      'common',
    ]);
    try {
      const result = await ssrFn(context);
      return  {
        ...result,
        props: {
          ...(result as { props: T | Promise<T> }).props,
          ...(await serverSideTranslations(locale || 'fa', ['common'])),

        }
      }
    } catch (error) {
      res.statusCode = 404;
      if (error instanceof ResponseError) {
        res.statusCode = error.data?.status || 500;
        return {
          props: {
            errorStatus: error.data?.status,
            ...localeProps,
          },
        };
      }
      return {
        props: {
          errorStatus: 400,
          ...localeProps,
        },
      };
    }
  };

  return {
    PageModule: withGetLayout(pageModule, pageType),
    getServerSideProps,
  };
};
